export default __webpack_public_path__ + "25cf84eab89ce588b4d3b0efeb510f01.svg";